import currency from 'currency.js';

export function toPercent(value: number | string = 0, precision = 8) {
    return currency(value, { precision }).multiply(100);
}

export function toCoefficient(value: number | string = 0, precision = 8) {
    return currency(value, { precision }).divide(100);
}
